﻿import React from 'react';
import styled from 'styled-components';
import control from '../../../vendor/react-validation/hocs/control';

import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';

const TextInput = ({ error, isChanged, isUsed, ...allProps }) => {
    const { displayname, fieldWidth, textInputWrapperWidth, marginBottom, ...props} = allProps;

    return (
        <TextInputWrapper
            fieldWidth={fieldWidth}
            marginBottom={marginBottom}
            textInputWrapperWidth={textInputWrapperWidth}>

            <input type="text" {...props} {...( isChanged && isUsed && error ? {
                className: `is-invalid-input ${props.className}`
            } : { className: props.className } )} />
           
            {displayname &&
                <label htmlFor={props.id}>{displayname}</label>
            }

            {isChanged && isUsed && error}    
        </TextInputWrapper>
    );
}

const TextInputWrapper = styled.div`
    width: ${props => props.textInputWrapperWidth ? props.textInputWrapperWidth : '100%'}; 
    ${mediaQuery.medium(`
        width: 100%;
    `)}

    input[type=text] {
        width: ${props => props.fieldWidth ? props.fieldWidth : '100%'}; 

        padding: 12px;
        //margin-bottom: 27px; 
        margin-bottom: ${props => props.marginBottom ? props.marginBottom : '10px'}; 
        
        background-color: ${definitions.colors.grayBackground};
        border: 1px solid ${definitions.colors.grayBorder};

        font-family: ${definitions.fonts.main};
        font-size: 18px;

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }
        ${mediaQuery.medium(`
            width: 95%;
        `)}
        ${mediaQuery.small(`
            font-size: 13px;
            padding: 5px;
            width: 100%;
        `)}
    }

    input[type=text]::placeholder {
        opacity: 0.3; 
    }

    input[type=text].is-invalid-input {
        border: 1px solid ${definitions.colors.error};
        margin-bottom: 0px; 
    }
`;

export default control(TextInput);